import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Textarea', null, {
    // eslint-disable-next-line react/display-name
    innerDependence: ({ rows, cols, invalid, noresize, source, ...textareaProps }, ref) => {
        return <textarea {...textareaProps} ref={ref} />;
    },
});
